import { ListApprovalsResponseSchema } from './list-approvals.schema';
export const listApprovalsContract = {
    method: 'GET',
    path: '/api/v2/approvals',
    description: 'List the approvals the caller may see',
    responseSchema: ListApprovalsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-approvals.contract.js.map